import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import PageActionBar from "../PageActionBar";
import PageActionButton from "../PageActionButton";

const ActionBarRow = ({ actions, onBack, backLabel, sx = {} }) => (
  <PageActionBar sx={sx}>
    <Box
      sx={{
        display: "flex",
        justifyContent: onBack ? "space-between" : "flex-end",
        alignItems: "center",
        width: "100%",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {onBack ? (
        <PageActionButton onClick={onBack} startIcon={<ArrowBack />}>
          {backLabel}
        </PageActionButton>
      ) : null}
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", ml: "auto" }}>
        {actions}
      </Box>
    </Box>
  </PageActionBar>
);

ActionBarRow.propTypes = {
  actions: PropTypes.node,
  onBack: PropTypes.func,
  backLabel: PropTypes.node,
  sx: PropTypes.object,
};

/**
 * Form sayfalarında aksiyon çubuğunu formun altında gösterir.
 * Geri butonu solda, kayıt/gönder aksiyonları sağda yer alır.
 */
const FormPageActionBars = ({ children, renderActions, onBack, backLabel }) => (
  <>
    {children}
    <ActionBarRow
      actions={renderActions()}
      onBack={onBack}
      backLabel={backLabel}
      sx={{ mt: 3, mb: 0 }}
    />
  </>
);

FormPageActionBars.propTypes = {
  children: PropTypes.node,
  renderActions: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  backLabel: PropTypes.node.isRequired,
};

export default FormPageActionBars;
